module.exports = __webpack_public_path__ + "static/media/d10.3e6a7e7e.png";